import React from "react";

const ExpBar = () => (
  <>
    <div className="exp-rule">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div className="noborder"></div>
    </div>
    <div className="exp-time">
      <div className="text-left">Exp (mois)</div>
      <div>1</div>
      <div>2</div>
      <div>3</div>
      <div>4</div>
      <div>6</div>
      <div>9</div>
      <div>12</div>
      <div>15</div>
      <div>18</div>
    </div>
  </>
);

export default ExpBar;
